import { Search, Hammer, Workflow, LineChart } from "lucide-react";
import { useI18n } from "../i18n";
import { SectionHeading } from "./ui/card";
import { Reveal } from "./reveal";

/** Método Vorto — quatro colunas separadas por hairlines verticais,
    número serifado gigante como marca de capítulo. */
export function Process() {
  const { t } = useI18n();
  const passos = [
    { n: "01", icon: Search, titulo: t("proc.p1.t"), desc: t("proc.p1.d") },
    { n: "02", icon: Hammer, titulo: t("proc.p2.t"), desc: t("proc.p2.d") },
    { n: "03", icon: Workflow, titulo: t("proc.p3.t"), desc: t("proc.p3.d") },
    { n: "04", icon: LineChart, titulo: t("proc.p4.t"), desc: t("proc.p4.d") },
  ];

  return (
    <section id="processo" className="relative scroll-mt-24 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <SectionHeading
            index="03"
            label={t("proc.rotulo")}
            title={t("proc.titulo")}
            description={t("proc.desc")}
            className="mb-12 sm:mb-16"
          />
        </Reveal>

        <ol className="grid border-t border-line sm:grid-cols-2 lg:grid-cols-4">
          {passos.map((p, i) => (
            <Reveal key={p.titulo} delay={i * 0.07} className="h-full">
              <li className="group flex h-full flex-col gap-4 border-b border-line px-0 py-8 sm:border-b-0 sm:px-6 sm:py-10 sm:not-first:border-l lg:first:pl-0">
                <span className="font-display text-5xl leading-none font-medium text-line transition-colors duration-300 group-hover:text-accent/35 sm:text-6xl">
                  {p.n}
                </span>
                <span className="grid size-10 place-items-center rounded-lg bg-accent-soft text-accent">
                  <p.icon className="size-[18px]" strokeWidth={1.8} />
                </span>
                <div>
                  <h3 className="font-display text-lg font-medium tracking-tight">{p.titulo}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{p.desc}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
